import checkFF from '@webapp-next/lib/feature-flag';
import {
  tabHighlight,
  showSideTeamStatusBar,
  notyTabletUser,
  clearAllTooltip,
} from './helpers';
import {
  getRouter,
  getCurrentRouteParams,
  createWebappRoute,
} from '../helpers';
import { doRootRoster } from '@webapp-next/modules/schedule/router/helpers';

export default [
  // 'roster': 'doRootRoster',
  createWebappRoute({
    path: '/roster',
    name: 'roster-module',
    component() {
      console.log('ROUTER, roster');
      doRootRoster();
      return {};
    },
  }),

  // 'roster/:shiftId': 'runRostering',
  createWebappRoute({
    path: '/roster/:shiftId',
    name: 'roster-id-module',
    component() {
      console.log('ROUTER, roster/:shiftId');

      const { shiftId } = getCurrentRouteParams();

      notyTabletUser();

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('roster');
          $dtw.vwWorkplace.roster(shiftId);
        };
        return false;
      }

      tabHighlight('roster');
      showSideTeamStatusBar(false);
      $dtw.vwWorkplace.roster(shiftId);
      clearAllTooltip();

      return {};
    },
  }),

  // 'roster/:shiftId/area/:deptId': 'runRosteringByOpunitId',
  createWebappRoute({
    path: '/roster/:shiftId/area/:deptId',
    name: 'roster-id-area-id-module',
    component() {
      console.log('ROUTER, roster/:shiftId/area/:deptId');

      const { deptId } = getCurrentRouteParams();

      if (!$dt.canManageRoster()) {
        if (!$dt?.isMyDepartment(deptId)) {
          getRouter().push({ name: 'roster-module' });
          return;
        }
      }

      notyTabletUser();

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('roster');
          $dtw.vwWorkplace.rosterByDeptId(deptId);
        };
        return false;
      }

      tabHighlight('roster');
      showSideTeamStatusBar(false);
      $dtw.vwWorkplace.rosterByDeptId(deptId);
      clearAllTooltip();

      return {};
    },
  }),

  // 'roster/:shiftId/date/:ymd': 'runRosteringByYMD',
  createWebappRoute({
    path: '/roster/:shiftId/date/:ymd',
    name: 'roster-id-date-ymd-module',
    component() {
      console.log('ROUTER, roster/:shiftId/date/:ymd');

      const { ymd, shiftId } = getCurrentRouteParams();

      notyTabletUser();
      tabHighlight('roster');
      showSideTeamStatusBar(false);

      // TODO: verify the usage of this, it happens when $dtw.vwWorkplace dont exists
      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = () => $dtw.vwWorkplace.roster(shiftId, ymd);
        return false;
      }

      $dtw.vwWorkplace.roster(shiftId, ymd);
      clearAllTooltip();

      return {};
    },
  }),

  // 'roster/:shiftId/area/:deptId/date/:ymd': 'runRosteringByOpunitIdYMD',
  createWebappRoute({
    path: '/roster/:shiftId/area/:deptId/date/:ymd',
    name: 'roster-id-area-id-date-id-module',
    component() {
      console.log('ROUTER, roster/:shiftId/area/:deptId/date/:ymd');

      const { ymd, deptId, shiftId } = getCurrentRouteParams();

      if (!$dt.canManageRoster()) {
        if (!$dt?.isMyDepartment(deptId)) {
          getRouter().push({ name: 'roster-module' });
          return;
        }
      }

      notyTabletUser();

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('roster');
          $dtw.vwWorkplace.rosterByDeptId(deptId, ymd);
        };
        return false;
      }

      tabHighlight('roster');
      showSideTeamStatusBar(false);

      if (
        deptId?.indexOf(',') === -1 &&
        !$dt.featureFlags.check('LAUNCH_BRIGHTLY_LOCATION_SELECTOR')
      ) {
        $dtw.vwWorkplace.rosterByDeptId(deptId, ymd);
      } else {
        $dtw.vwWorkplace.rosterByIdByDeptId(shiftId, deptId, ymd);
      }
      clearAllTooltip();

      return {};
    },
  }),

  // 'roster/shift/:shiftId': 'scheduleShift',
  createWebappRoute({
    path: '/roster/shift/:shiftId',
    name: 'roster-shift-id-module',
    component() {
      console.log('ROUTER, roster/shift/:shiftId');

      const { shiftId } = getCurrentRouteParams();

      if (!checkFF('ptp-0-people-module-vue')) {
        VueEventBus.$emit(VueEvents.SCHEDULE.SHIFT_OPEN, shiftId);
        return;
      }

      doRootRoster();
      return {};
    },
  }),

  // 'roster/runByURL/*path': 'runRosteringByURL',
  createWebappRoute({
    path: '/roster/runByURL/*path',
    name: 'roster-run-by-url-module',
    component() {
      console.log('ROUTER, roster/runByURL/*path');

      const { path } = getCurrentRouteParams();
      notyTabletUser();

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('roster');
          $dtw.vwWorkplace.rosterByUrl(path);
        };
        return false;
      }

      tabHighlight('roster');
      showSideTeamStatusBar(false);
      $dtw.vwWorkplace.rosterByUrl(path);
      clearAllTooltip();

      return {};
    },
  }),

  // 'roster/record/:shiftId': 'runRosteringById',
  createWebappRoute({
    path: '/roster/record/:shiftId',
    name: 'roster-record-id-module',
    component() {
      console.log('ROUTER, roster/record/:shiftId');

      const { shiftId } = getCurrentRouteParams();

      notyTabletUser();

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('roster');
          $dtw.vwWorkplace.rosterById(shiftId);
        };
        return false;
      }

      tabHighlight('roster');
      showSideTeamStatusBar(false);
      $dtw.vwWorkplace.rosterById(shiftId);
      clearAllTooltip();

      return {};
    },
  }),
];
